export function setCashReceipts (state, cashReceipts) {
	state.cashReceipts = cashReceipts
}

export function setPreloader (state, preloader) {
    state.preloader = preloader
}



// WEBPACK FOOTER //
// ./src/modules/cashReceipts/mutations.js